import React from 'react';
import { ArrowRight } from 'lucide-react';

interface FooterProps {
  onConsultationClick: () => void;
  onDemoClick: () => void;
  isDarkMode: boolean;
}

const Footer: React.FC<FooterProps> = ({ onConsultationClick, onDemoClick, isDarkMode }) => {
  return (
    <footer className={`py-16 ${isDarkMode ? 'bg-slate-950 text-white' : 'bg-slate-900 text-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            Partner with industry leaders trusted by 500+ organizations
          </h2>
          <p className="text-xl text-slate-300 max-w-4xl mx-auto mb-8">
            Join forward-thinking enterprises who choose CyberSoft to reduce operational risk, 
            ensure regulatory compliance, and protect their bottom line throughout their 
            digital transformation journey.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onConsultationClick}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center"
            >
              Schedule Consultation
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
            <button 
              onClick={onDemoClick}
              className="border border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-white px-8 py-4 rounded-lg font-semibold transition-colors"
            >
              Request Demo
            </button>
          </div>
        </div>
        
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center mb-4 md:mb-0">
              <img 
                src="https://res.cloudinary.com/durgvddoz/image/upload/v1754227885/cyberlogo_f4efdi.png" 
                alt="CyberSoft Logo" 
                className="h-10 w-auto"
              />
            </div>
            <div className="flex space-x-6 text-sm text-slate-400">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Security</a>
            </div>
          </div>
          <div className="text-center text-slate-400 text-sm mt-4">
            © 2024 CyberSoft. All rights reserved. Advanced Security Solutions.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;